/** Sklejanie klas Tailwinda (konwencja shadcn: clsx + tailwind-merge). */
import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
